import { DEFAULT_SITE_ORIGIN } from './absoluteSiteUrl.js';

/** Legacy marketing origins rewritten for tenant websites at render time. */
export const LEGACY_MARKETING_SITE_ORIGINS = [
  'https://www.toolsandbubbles.com',
  'https://toolsandbubbles.com',
  'http://www.toolsandbubbles.com',
  'http://toolsandbubbles.com',
] as const;

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/** Normalize website URL to origin without trailing slash. */
export function normalizeMarketingSiteOrigin(websiteUrl?: string): string | null {
  const trimmed = websiteUrl?.trim();
  if (!trimmed) return null;
  return trimmed.replace(/\/$/, '');
}

/** Replace legacy Tools & Bubbles absolute URLs with the tenant marketing origin. */
export function substituteMarketingSiteLinksInText(text: string, websiteUrl?: string): string {
  if (!text) return text;
  const origin = normalizeMarketingSiteOrigin(websiteUrl);
  if (!origin || origin === DEFAULT_SITE_ORIGIN) return text;

  let result = text;
  for (const legacy of LEGACY_MARKETING_SITE_ORIGINS) {
    result = result.replace(new RegExp(escapeRegExp(legacy), 'gi'), origin);
  }
  return result;
}

/** True when href points at the legacy or tenant marketing site (same-tab internal link). */
export function isMarketingSiteHref(href: string, websiteUrl?: string): boolean {
  if (!href.startsWith('http')) return true;
  try {
    const url = new URL(href);
    const host = url.hostname.toLowerCase();
    if (host.includes('toolsandbubbles.com')) return true;
    const tenantOrigin = normalizeMarketingSiteOrigin(websiteUrl);
    if (tenantOrigin) {
      const tenantHost = new URL(tenantOrigin).hostname.toLowerCase();
      if (host === tenantHost) return true;
    }
    return false;
  } catch {
    return false;
  }
}

/** Resolve a corpus href for the active tenant (legacy domain → tenant origin). */
export function resolveMarketingSiteHref(href: string, websiteUrl?: string): string {
  if (!href.startsWith('http')) return href;
  return substituteMarketingSiteLinksInText(href, websiteUrl);
}
